import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    position: "absolute",
    zIndex: 50,
    height: "100%",
    width: "100%",
    backgroundColor: "white",
    padding: "50px",
    textAlign: "justify",
    overflowY: "scroll",
  },
});

const Privacy = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <strong>Política de Privacidad</strong>
      <br />
      <br />
      SinaloaCovidApp se creó para responder a la pandemia del Covid-19 en
      Sinaloa y formar un estado más informado y más consciente. En esta web app
      tomamos la privacidad de los usuarios como un tema serio. En esta política
      de privacidad se explicará cómo manejamos los datos de los usuarios.
      <br />
      <br />
      <strong>Datos recolectados</strong>
      <br />
      <br />
      SinaloaCovidApp no almacena la información de los usuarios en ningún
      servidor ni base de datos que esta posea por varias razones. La primera es
      que no existe back-end en la aplicación, es decir, que es una página
      estática, por lo que simplemente no tiene ningún lugar donde guardar la
      información. La app usa la funcionalidad navigator.userAgent para saber el
      navegador del cual nos visitan *safari, chrome, etc.*, y así mostrar un
      mensaje de bienvenida, pero no se guardan datos de eso.
      <br />
      <br />
      <strong>Datos mostrados</strong>
      <br />
      <br />
      La información que se muestra en SinaloaCovidApp proviene de páginas
      oficiales del Gobierno del Estado de Sinaloa y la Secretaría de Salud.
      Dichas páginas están referenciadas dentro de la pestaña de información
      dentro de la aplicación. SinaloaCovidApp muestra información confiable
      basada en fuentes oficiales y se actualiza constantemente. La app cuenta
      con el permiso por parte de la Secretaría de Salud del Estado de Sinaloa
      para ser subida a las tiendas de aplicaciones y utilizar los datos ya
      existentes en las páginas del Gobierno del Estado de Sinaloa.
      <br />
      <br />
      <strong>Analíticas y compartir datos a terceros</strong>
      <br />
      <br />
      SinaloaCovidApp cuenta con el uso del Servicio de Google Analyticis, el
      cual recolecta información de manera general de la cantidad de usuarios
      que ingresan o visitan la aplicación. Google Analytics podría estar usando
      Cookies, por eso se recomienda leer su propia política de privacidad en su
      página https://analytics.google.com/. La idea de usar analíticas no es
      para usar o almacenar malintencionadamente datos de los usuarios, sino que
      esta información ayuda a mejorar la página, darle mantenimiento, ayudarla
      a crecer y tener un panorama más amplio de los usuarios que ingresan a la
      app. Google Analytics solo muestra una vista general de las personas que
      acceden a la web app, es decir que no se muestran datos individuales de
      los usuarios. Google Analytics también protege los datos de los usuarios
      cumpliendo con las políticas establecidas en la AppStore y la Google Play
      Store.
      <br />
      <br />
      <strong>Cómo usamos y recolectamos los datos</strong>
      <br />
      <br />
      SinaloaCovidApp no almacena datos de los usuarios en ningún servidor.
      Google Analyitics es un servicio de terceros que provee información de la
      audiencia que visita la página. Esta información se usa para medir el
      impacto que tiene SinaloaCovidApp en la ciudadanía.
      <br />
      <br />
      <strong>Seguridad</strong>
      <br />
      <br />
      La app no almacena datos de sus usuarios, por lo que la información
      personal sensible no está disponible en ninguno de los servidores de
      SinaloaCovidApp. La app cuenta con un cifrado HTTPS que es el protocolo
      seguro para navegar en la red. Los datos de terceros son protegidos por
      Google Analytics.
      <br />
      <br />
      <strong>Retención y eliminado de datos</strong>
      <br />
      <br />
      Como ya se mencionó, SinaloaCovidApp no cuenta con servidores que
      almacenen la información de sus usuarios, por tal motivo, los datos de los
      usuarios no son guardados en la app. La eliminación de datos es
      irrelevante en este escenario porque los datos no se guardan de nuestra
      parte.
      <br />
      <br />
    </div>
  );
};

export default Privacy;
